export * from './customer-routing.module';
export * from './customer.module';
export * from './customer.routes';
